import { render, staticRenderFns } from "./Panier_Container.vue?vue&type=template&id=12a45176&scoped=true&"
import script from "./Panier_Container.vue?vue&type=script&lang=js&"
export * from "./Panier_Container.vue?vue&type=script&lang=js&"
import style0 from "./Panier_Container.vue?vue&type=style&index=0&id=12a45176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a45176",
  null
  
)

export default component.exports